import { render, staticRenderFns } from "./insurancechannel-info-modal.vue?vue&type=template&id=5e5052e3"
import script from "./insurancechannel-info-modal.vue?vue&type=script&lang=js"
export * from "./insurancechannel-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports